// Full-screen navigation overlay toggled by the "Menu" button in the header
// (templates/partials/menu.html).

const BUTTON = document.querySelector('#navbar-button')
const MENU = document.querySelector('#navbar')

if (BUTTON && MENU) {
    const ROOT = document.documentElement
    const BUTTON_ICON_OPEN = BUTTON.querySelector('#navbar-button__open')
    const BUTTON_ICON_CLOSE = BUTTON.querySelector('#navbar-button__close')
    const BUTTON_ICON_TEXT = BUTTON.querySelector('#navbar-button__text')

    const FOCUSABLE =
        'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'

    // Looked up on each Tab, as some items (e.g. Install app, Privacy
    // settings) are only unhidden after load, or never
    const getVisibleFocusables = () =>
        Array.from(MENU.querySelectorAll(FOCUSABLE)).filter(
            (element) => element.getClientRects().length > 0
        )

    let isMenuOpen = false

    const setMenuState = (open) => {
        if (open === isMenuOpen) return
        isMenuOpen = open

        BUTTON.setAttribute('aria-expanded', open)
        MENU.setAttribute('aria-hidden', !open)
        BUTTON_ICON_OPEN.classList.toggle('hidden!', open)
        BUTTON_ICON_CLOSE.classList.toggle('hidden!', !open)
        // Locked on <html> rather than <body>, which already carries
        // overflow-hidden on the game pages (see base.html).
        ROOT.classList.toggle('overflow-hidden', open)

        if (open) {
            BUTTON.setAttribute('aria-label', 'Close navigation')
            BUTTON_ICON_TEXT.textContent = 'Close'
            MENU.classList.replace('opacity-0', 'opacity-100')
            MENU.classList.remove('pointer-events-none')
            MENU.removeAttribute('inert')
            getVisibleFocusables()[0]?.focus()
        } else {
            BUTTON.setAttribute('aria-label', 'Open navigation')
            BUTTON_ICON_TEXT.textContent = 'Menu'
            MENU.classList.replace('opacity-100', 'opacity-0')
            MENU.setAttribute('inert', '')
            // Matches the overlay's duration-200 fade
            setTimeout(() => {
                if (!isMenuOpen) MENU.classList.add('pointer-events-none')
            }, 200)
        }
    }

    BUTTON.addEventListener('click', () => setMenuState(!isMenuOpen))

    // Close before a11y-dialog's (document-level) opener handler runs, so
    // the dialog records the menu button as the element to restore focus to
    // rather than the Rules button inside the now-inert overlay.
    MENU.addEventListener('click', (event) => {
        if (event.target.closest('[data-a11y-dialog-show]')) {
            setMenuState(false)
            BUTTON.focus()
        }
    })

    document.addEventListener('keydown', (event) => {
        if (!isMenuOpen) return

        if (event.key === 'Escape') {
            setMenuState(false)
            BUTTON.focus()
            return
        }

        // Trap focus inside the menu, with the toggle button as part of the loop
        if (event.key === 'Tab') {
            const focusables = getVisibleFocusables()
            const firstElement = focusables[0]
            const lastElement = focusables[focusables.length - 1]
            if (!firstElement) return
            const active = document.activeElement
            if (event.shiftKey) {
                if (active === BUTTON) {
                    event.preventDefault()
                    lastElement.focus()
                } else if (active === firstElement) {
                    event.preventDefault()
                    BUTTON.focus()
                }
            } else {
                if (active === BUTTON) {
                    event.preventDefault()
                    firstElement.focus()
                } else if (active === lastElement) {
                    event.preventDefault()
                    BUTTON.focus()
                }
            }
        }
    })
}
